module.exports = {
        srcSet: __webpack_public_path__ + "amenities_starbucks_DE-528-852329cf4176167e.digested.png"+" 528w",
        images: [{path: __webpack_public_path__ + "amenities_starbucks_DE-528-852329cf4176167e.digested.png",width: 528,height: 528}],
        src: __webpack_public_path__ + "amenities_starbucks_DE-528-852329cf4176167e.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_starbucks_DE-528-852329cf4176167e.digested.png"},
        
        width: 528,
        height: 528
      }